import restApi from "../../http.js";
import session from "../session";

export default class contentManagment {
  getFeaturedCollections() {
    return restApi({
      method: "GET",
      url: "/views/homepage/containers?type=FEATURED_COLLECTIONS",
    });
  }
  updateFeaturedCollections(data) {
    return restApi({
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
      method: "PUT",
      url: "/views/homepage/containers/FEATURED_COLLECTIONS",
      data: data,
    });
  }
  getHero() {
    return restApi({
      method: "GET",
      url: "/views/homepage/containers?type=HERO",
    });
  }
  updateHero(data) {
    return restApi({
      method: "PUT",
      url: "/views/homepage/containers/HERO",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
      data: data,
    });
  }
  getFeaturedBrands() {
    return restApi({
      method: "GET",
      url: "/views/homepage/containers?type=FEATURED_BRANDS",
    });
  }
  updateFeaturedBrands(data) {
    return restApi({
      headers: { Authorization: "Bearer " + session.getAccessToken() },
      method: "PUT",
      url: "/views/homepage/containers/FEATURED_BRANDS",
      data: data,
    });
  }
  getTrendingBrands() {
    return restApi({
      method: "GET",
      url: "/views/homepage/containers?type=TRENDING_BRANDS",
    });
  }
  updateTrendingBrands(data) {
    return restApi({
      headers: { Authorization: "Bearer " + session.getAccessToken() },
      method: "PUT",
      url: "/views/homepage/containers/TRENDING_BRANDS",
      data: data,
    });
  }
  getAbout() {
    return restApi({
      method: "GET",
      url: "views/homepage/containers?type=ABOUT",
    });
  }
  updateAbout(data) {
    return restApi({
      headers: { Authorization: "Bearer " + session.getAccessToken() },
      method: "PUT",
      url: "/views/homepage/containers/ABOUT",
      data: data,
    });
  }

  getCollectionsCarousel() {
    return restApi({
      method: "GET",
      url: "/views/homepage/containers?type=PERFECT_FOR_THE",
    });
  }

  updateCollectionsCarousel(request) {
    return restApi({
      method: "PUT",
      url: "/views/homepage/containers/PERFECT_FOR_THE",
      data: request,
      headers: { Authorization: "Bearer " + session.getAccessToken() },
    });
  }

  uploadFile(file) {
    return restApi({
      method: "POST",
      url: "/files",
      data: file,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
}
